import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { ITblSubmissionStatus } from "../../models/TblSubmissionStatus";
import { IPipelineMast } from "../../models/PipelineMast";

interface Iprops {
    submission_ID: number,
    consultant_Name?: string,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    row: IPipelineMast
}

export const LifeCycle = (props: Iprops) => {
    const onHide = () => {
        props.hideDialog();
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`History against Submission Rejection for SubmissionID - ${props.submission_ID}`} modal className="p-fluid" onHide={onHide}>
            <hr />
            <div className="mb-3">
                <p className="flex gap-3"><span style={{ width: '13rem' }}>Sales Rejection Status</span><span>:</span><span style={{ width: '80%' }}>{props.row?.status_Name}</span></p>
                <p className="flex gap-3"><span style={{ width: '13rem' }}>Sales Rejection Sub Status</span><span>:</span><span style={{ width: '80%' }}>{props.row?.rejection_Status}</span></p>
                <p className="flex gap-3"><span style={{ width: '13rem' }}>Sales Rejection Comment</span><span>:</span><span style={{ width: '80%' }}>{props.row?.comments}</span></p>
                <p className="flex gap-3"><span style={{ width: '13rem' }}>Recruiter Accept/Deny Rej</span><span>:</span><span style={{ width: '80%' }}>{(props?.row?.isAccepted != null || props?.row?.isAccepted != undefined) ? (props?.row.isAccepted === true ? 'Accept' : 'Deny') : 'Not Yet Responded'}</span></p>
                <p className="flex gap-3"><span style={{ width: '13rem' }}>Recruiter Comment</span><span>:</span><span style={{ width: '80%' }}>{(props?.row?.acknowledgement != null || props?.row?.acknowledgement != undefined) ? props.row?.acknowledgement  : 'Not Yet Responded'}</span></p>
            </div>
        </Dialog>
    );
}
